module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-autocomplete', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curVal),
      expression: "curVal"
    }],
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.curVal)
    },
    on: {
      "select": _vm.handleSelectField,
      "input": function($event) {
        _vm.curVal = $event
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4580501e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputs/honrayDropdownInput.vue
// module id = 1843
// module chunks = 2